<template>
  <base-layout page-default-back-link="/Informazioni">
    <div>
      <div style="height: 40px">
        <h3 v-html="Titolo.Gruppo" style="text-align: center"></h3>
      </div>
    </div>
    <ion-list v-if="arcSezioni.length > 1" style="padding-left: 10px">
      <div v-for="item in arcSezioni" :key="item.Titolo">
        <p style="font-weight: bold"><a v-if="item.Titolo.length > 0" v-html="item.Titolo" @click="scrollTo(item.Titolo)"></a></p>
      </div>
    </ion-list>

    <ion-list>
      <div v-for="item in arcAnteprima" :key="item.Titolo" style="padding: 10px" :ref="item.Titolo">
        <h3 v-html="item.Titolo"></h3>
        <div v-if="item.Ins_posi == 1" style="width: 100%">
          <div class="center" v-if="item.Ins_dimi != '0px'">
            <img v-if="item.Ins_imag != null" v-bind:src="$SITE_URL + item.Ins_imag" style="max-height: 300px" />
          </div>
          <div style="float: none; padding-top: 20px"><p v-html="item.Info"></p></div>
        </div>

        <!-- immagine a destra e testo a sinistra -->
        <div v-if="item.Ins_posi == 2" style="width: 100%">
          <div :style="{ float: 'right', width: item.Ins_dimi, 'margin-left': '10px' }" v-if="item.Ins_dimi != '0px'">
            <img v-if="item.Ins_imag != null" v-bind:src="$SITE_URL + item.Ins_imag" :style="{ width: item.Ins_dimi }" />
          </div>
          <div style="float: none"><p align="justify" v-html="item.Info"></p></div>
        </div>

        <!-- immagine sotto e testo sopra -->
        <div v-if="item.Ins_posi == 3" style="width: 100%">
          <div style="float: none; padding-bottom: 20px"><p v-html="item.Info"></p></div>
          <div class="center" v-if="item.Ins_dimi != '0px'">
            <img v-if="item.Ins_imag != null" v-bind:src="$SITE_URL + item.Ins_imag" style="max-height: 300px" />
          </div>
        </div>

        <!-- immagine a sinistra e testo a destra -->
        <div v-if="item.Ins_posi == 4" style="width: 100%">
          <div :style="{ float: 'left', width: item.Ins_dimi, 'margin-right': '10px' }" v-if="item.Ins_dimi != '0px'">
            <img v-if="item.Ins_imag != null" v-bind:src="$SITE_URL + item.Ins_imag" :style="{ width: item.Ins_dimi }" />
          </div>
          <div style="float: none"><p align="justify" v-html="item.Info"></p></div>
        </div>
      </div>
    </ion-list>
  </base-layout>
</template>

<script>
import { BaseLayout, IonList } from "@ionic/vue";
import { DbParamType } from "../components/shared/DbParamType";
import { CommandExecutionType } from "../components/shared/CommandExecutionType";
import { ParameterDirection } from "../components/shared/ParameterDirection";
import { CommandParam } from "../components/shared/CommandParam";
import { dataBoxCall } from "../components/shared/GlobalCallSP";

export default {
  name: "InformazioniDet",
  components: {
    BaseLayout,
    IonList,
  },
  data() {
    return {
      arcAnteprima: [],
      Titolo: {},
      arcSezioni: [],
      pIns_grup: "",
    };
  },
  methods: {
    scrollTo(refName) {
      try{
        var elements = this.$refs[refName];
        //var top = elements[0].offsetTop;
        //window.scrollTo(0, top);
        elements[0].scrollIntoView({ behavior: 'smooth' });
        
      }catch(er){
        console.log("elemento non trovato" + er)
      }
    },
    EstraiDati() {
      const self = this;
      let prm = [];
      // inline
      prm.push(new CommandParam("@Ins_grup", "", DbParamType.AnsiString, 200, ParameterDirection.Input, this.pIns_grup));
      prm.push(new CommandParam("@Lin_codi", "", DbParamType.Int32, 0, ParameterDirection.Input, this.$LIN_CODI));
      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));
      dataBoxCall
        .Exec(prm, "stpF_Anagrafica_Indirizzi_InfoSezioni_Gruppo_Anteprima02_lst", true, "", CommandExecutionType.ExecuteQuery, false, this.$DATABOX_CFG)
        .then(function (data) {
          if (data && data.RecordSet.Table.length > 0) {
            self.arcAnteprima = data.RecordSet.Table;
            self.Titolo = data.RecordSet.Table[0];
            self.arcSezioni = data.RecordSet.Table1;
          } else {
            self.arcSezioni = [];
          }
        })
        .catch(function (er) {
          console.log("return normale no data" + er);
        });
    },
  },
  mounted() {
    this.pIns_grup = this.$route.params.pIns_grup;
    this.EstraiDati();
  },
};
</script>
